import { FEEDBACK_MODEL_ASSOCIATIONS, FEEDBACK_MODEL_CLASS_NAME } from '../../../models/feedback/constants'
import { PROFILE_ASSOCIATIONS, PROFILE_CLASS_NAME } from '../../../models/profile/constants'
import { DAY_ASSOCIATION_KEYS, DAY_CLASS_NAME } from '../../day'
import { EXERCISE_ASSOCIATION_KEYS, EXERCISE_CLASS_NAME } from '../../exercise'
import { MESSAGE_ASSOCIATIONS, MESSAGE_CLASS_NAME } from '../../message'
import { PLAN_ASSOCIATION_KEYS, PLAN_CLASS_NAME, PLAN_KEY } from '../../plan/model/constants'
import { POST_ASSOCIATIONS, POST_CLASS_NAME } from '../../post/model/constants'
import { WORKOUT_ASSOCIATION_KEYS, WORKOUT_CLASS_NAME, WORKOUT_KEY } from '../../workout/model/constants'
import { WORKOUT_EXERCISE_ASSOCIATIONS, WORKOUT_EXERCISE_CLASS_NAME } from '../../workout-exercise/model/constants'
import { WORKOUT_SECTION_ASSOCIATIONS, WORKOUT_SECTION_CLASS_NAME } from '../../workout-section/model/constants'
import { EXERCISE_LOG_ASSOCIATIONS, EXERCISE_LOG_CLASS_NAME } from '../../exercise-log/model/constants'
import {
  EXERCISE_LOG_SUMMARY_ASSOCIATIONS,
  EXERCISE_LOG_SUMMARY_CLASS_NAME
} from '../../exercise-log-summary/model/constants'
import { USER_ASSOCIATIONS, USER_CLASS_NAME } from '../../user/model/constants'
import { MEAL_MODEL_ASSOCIATION_KEYS, MEAL_MODEL_CLASS_NAME } from '../../meal'

const REDUX_ASSOCIATION = {
  [EXERCISE_LOG_CLASS_NAME]: EXERCISE_LOG_ASSOCIATIONS,
  [EXERCISE_CLASS_NAME]: EXERCISE_ASSOCIATION_KEYS,
  [EXERCISE_LOG_SUMMARY_CLASS_NAME]: EXERCISE_LOG_SUMMARY_ASSOCIATIONS,
  [FEEDBACK_MODEL_CLASS_NAME]: FEEDBACK_MODEL_ASSOCIATIONS,
  [PLAN_CLASS_NAME]: PLAN_ASSOCIATION_KEYS,
  [MESSAGE_CLASS_NAME]: MESSAGE_ASSOCIATIONS,
  [DAY_CLASS_NAME]: DAY_ASSOCIATION_KEYS,
  [MEAL_MODEL_CLASS_NAME]: MEAL_MODEL_ASSOCIATION_KEYS,
  [POST_CLASS_NAME]: POST_ASSOCIATIONS,
  [PROFILE_CLASS_NAME]: PROFILE_ASSOCIATIONS,
  [USER_CLASS_NAME]: USER_ASSOCIATIONS,
  [WORKOUT_CLASS_NAME]: WORKOUT_ASSOCIATION_KEYS,
  [WORKOUT_EXERCISE_CLASS_NAME]: WORKOUT_EXERCISE_ASSOCIATIONS,
  [WORKOUT_SECTION_CLASS_NAME]: WORKOUT_SECTION_ASSOCIATIONS
}

export const REDUX_OPTIONAL_ASSOCIATION_KEYS = {
  [WORKOUT_CLASS_NAME]: [
    WORKOUT_KEY.EXERCISE_LOGS,
    WORKOUT_KEY.PROFILES_WHO_STARTED,
    WORKOUT_KEY.MEDIA
  ],
  [PLAN_CLASS_NAME]: [
    PLAN_KEY.WELCOME_MEDIA,
    PLAN_KEY.MEDIA,
    PLAN_KEY.PROFILES_WHO_STARTED
  ]
}

export const REDUX_ASSOCIATION_TO_SAVE = {
  [EXERCISE_CLASS_NAME]: EXERCISE_ASSOCIATION_KEYS,
  [PROFILE_CLASS_NAME]: PROFILE_ASSOCIATIONS
}

export default REDUX_ASSOCIATION
